module.exports = __webpack_public_path__ + "img/sea-1.651ad66d.jpg";